import { render, staticRenderFns } from "./PdfConfiguration.vue?vue&type=template&id=52bbfe11&"
import script from "./PdfConfiguration.vue?vue&type=script&lang=js&"
export * from "./PdfConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports